import { useLang } from '@/i18n';
import EFComputer from 'elem/ui-assets/icons/appliances/EFComputer';
import EFGamingConsole from 'elem/ui-assets/icons/appliances/EFGamingConsole';
import EFNAS from 'elem/ui-assets/icons/appliances/EFNAS';
import EFRefrigerator from 'elem/ui-assets/icons/appliances/EFRefrigerator';
import EFWiFi from 'elem/ui-assets/icons/appliances/EFWiFi';
import EfImg from 'elem/ui/ef-img';
import EfInfoSection from 'elem/ui/ef-info-section';
import EfSpec from 'elem/ui/ef-spec';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';
import EFFan from '@elem/ui-assets/icons/appliances/EFFan';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionC');
    const { locale = 'us' } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale);
    const IS_EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale);
    const { pageStatus } = useProductStore();

    const imgAllA = {
        NA: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1724577123756/_10%20ms.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1724577123593/_10%20ms%20(1).jpg',
        },
        EU: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725010886809/euPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725010886702/euH1.jpg',
        },
        UK: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725010887124/ukPC1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725010887291/ukH1.jpg',
        },
        PH: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1751091130306/E.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1751091130144/E-m.jpg',
        },
    };
    const imgLocaleA: any = {
        us: imgAllA.NA,
        ca: imgAllA.NA,
        br: imgAllA.NA,
        mx: imgAllA.NA,
        uk: imgAllA.UK,
        eu: imgAllA.EU,
        de: imgAllA.EU,
        fr: imgAllA.EU,
        it: imgAllA.EU,
        es: imgAllA.EU,
        ph: imgAllA.PH,
    };
    const imgA = imgLocaleA[locale] || imgLocaleA['eu'];
    let items = [
        {
            icon: <EFRefrigerator />,
            text: t('item1'),
        },
        {
            icon: <EFComputer />,
            text: t('item2'),
        },
        {
            icon: <EFNAS />,
            text: t('item3'),
        },
        {
            icon: <EFWiFi />,
            text: t('item4'),
        },
        {
            icon: <EFGamingConsole />,
            text: t('item5'),
        },
    ];

    if (locale === 'ph') {
        items = [
            {
                icon: <EFWiFi />,
                text: t('item1'),
            },
            {
                icon: <EFComputer />,
                text: t('item2'),
            },
            {
                icon: <EFFan />,
                text: t('item3'),
            },
            {
                icon: <EFRefrigerator />,
                text: t('item4'),
            },
        ];
    }

    return (
        <div className={styles.TheComp}>
            <EfSpec className="spec-x" />
            <EfInfoSection title={t('title')} desc={t('desc')} />
            <ul className="items">
                {items?.map((item: any, k: number) => (
                    <li className="item" key={k}>
                        <div className="item-icon">{item.icon}</div>
                        <p className="item-text">{item.text}</p>
                    </li>
                ))}
            </ul>
            <EfImg pc={imgA.pc} h5={imgA.h5} />
        </div>
    );
}
